import React from "react";
import Dropzones from "../AddPlan/Dropzones";
import Box from "./Box";

const RetriggerDropzoneStyle = {
  height: "166px",
  width: "450px",
  background: "#ebf8ff",
  border: "2px dashed #bdbdbd",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  flexDirection: "column",
  fontSize: "16px",
  marginTop: "30px",
};

function Checkbox({ checked, checked1, onChange, label, updateUploadedFile, updateError }) {
  return (
    <div className="checkbox-container">
      <Box
        checked={checked}
        checked1={checked1}
        label={label}
        onChange={onChange}
      />

      {checked1 && (
        <Dropzones
          RetriggerDropzoneStyle={RetriggerDropzoneStyle}
          onFilesAdded={console.log}
          updateUploadedFile={updateUploadedFile}
          updateError={updateError}
          reRun={true}
        />
      )}
    </div>
  );
}

export default Checkbox;
